export default {
  // the popup timeout in milliseconds
  notificationDuration: 7000,

  transitionEnterTimeout: 500,
  transitionLeaveTimeout: 300,
};
